import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import ViewYearlyEvaluationForm from "../../components/ViewYearlyEvaluationForm/ViewYearlyEvaluationForm";
import Layout from "../../components/shared/Layout/Layout";

const ViewYearlyEvaluation = ({ grades, getGradeList }) => {
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`Yearly Evaluation`}>
        <ViewYearlyEvaluationForm grades={grades} />
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(ViewYearlyEvaluation);
